export enum LocalStorageKey {
  TOKEN = "Token",
  LANGUAGE = "language",
  INFO_TEXT_VISIBLE = "infotexteVisible",
  SESSION_ID = "SessionID",
  SAVED_COLORS = "savedColors"
}
